import style from './style.module.scss'
import classnames from 'classnames'
import { Header } from '@crossfit/design-system'

type Props = {
  isMenuOpen: boolean
  isLoggedIn: boolean
  onLogin: () => void
  onClick: () => void
  profileImage: string
  firstChar: string
}

export const AccountButton = ({
  isMenuOpen,
  isLoggedIn,
  onLogin,
  onClick,
  profileImage,
  firstChar,
}: Props) => {
  const hasImage = () =>
    profileImage && !profileImage.includes('crossfit.com/athlete-avatar')

  return (
    <button
      className={classnames(
        style.icon,
        isMenuOpen && style.active,
        isLoggedIn && hasImage() && style.image,
        isLoggedIn && !hasImage() && style.noImage,
      )}
      onClick={() => (isLoggedIn ? onClick() : onLogin)}
      aria-label='Account Toggle'
    >
      {hasImage() ? (
        <img src={profileImage} alt='Profile Avatar' />
      ) : (
        <div className={style.noImageLogo}>
          <Header as='h5' className={style.noImageLogoText} size='xs'>
            {firstChar}
          </Header>
        </div>
      )}
    </button>
  )
}
